export const KeyResultUnit = {
    NUMBER: 'Number',
    PERCENTAGE: 'Percentage',
    MONETARY: 'Monetary',
    YES_NO: 'YesNo',
} as const;

export type KeyResultUnitValue = (typeof KeyResultUnit)[keyof typeof KeyResultUnit];
